<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div class="card package h-100 p-3">
        <div v-if="!!headerHtml" v-html="headerHtml"></div>
        <table :class="`table table-responsive-md table-no-top-border table-sm my-2`">
          <thead>
            <tr>
              <th role="columnheader">{{ trans('participant') }}</th>
            </tr>
          </thead>
          <tbody v-if="!!participants && participants.length > 0">
            <tr v-for="(participant, index) in participants" :key="index">
              <td class="align-middle">{{ participant.name }}</td>
            </tr>
          </tbody>
          <tbody v-if="!participants || participants.length == 0">
            <tr>
              <td class="align-middle text-center p-4">
                <em class="text-muted">
                  {{ trans('none') }}
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!!footerHtml" v-html="footerHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      isPreview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        isNumeric: _.isNumeric,
        currency: _.currency,
        cls: null,
        event: null,
        participants: null,
      }
    },
    computed: {
      headerHtml() {
        if (!this.block) return null
        let placeholders = _.createPlaceholdersForClassEvent(this.cls, this.event)
        return _.replacePlaceholders(this.block.text, placeholders)
      },
      footerHtml() {
        if (!this.block) return null
        let placeholders = _.createPlaceholdersForClassEvent(this.cls, this.event)
        return _.replacePlaceholders(this.block.text2, placeholders)
      },
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
    },
    watch: {
      block() {
        this.fetch()
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        if (this.isPreview) {
          let url = `/organization/${this.organization.id}/page/${this.page.id}/simulate_attendance`
          axios.post(url, this.block)
          .then(response => {
            this.busy = false
            this.cls = response.data.class || null
            this.event = response.data.event || null
            this.participants = response.data.participants || []
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        } else {
          let slug = (this.page.slug || '').replace('/', '') || 'undefined'
          let url = `/org/${this.organization.id}/page/${this.page.upid}/${slug}/class/${this.block.id}/attendance`
          axios.get(url)
          .then(response => {
            this.busy = false
            this.cls = response.data.class || null
            this.event = response.data.event || null
            this.participants = response.data.participants || []
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        }
      },
    },
    mounted() {
      window['pageAttendance'+(!!this.block ? this.block.id || '' : '')] = this
      this.fetch()
    },
  }
</script>